import { axiosSwagger } from "@/axios";



export const state = {
  // file
  file: {
    loading: false,
    data: [],
  },
  selectedIds: {
    id: [],
    data: [],
  }
}


export const getters = {
}


export const mutations = {
  // FILE
  fileLoading: (state, loading) => {
    state.file.loading = loading;
  },
  setFileData: (state, data) => {
    state.file.data = data;
  },
  removeFileData: (state) => {
    state.file.data = [];
  },
  // SELECTED IDS
  setSelectedMultiple: (state, data) => {
    if(!state.selectedIds.id.includes(data.id)){
      // add ids
      state.selectedIds.id.push(data.id);
  
      // add data
      state.selectedIds.data.push(data);
    }
  },
  removeSelectedMultiple: (state, data) => {
    // remove ids array
    state.selectedIds.id = state.selectedIds.id.filter((fileId) => fileId !== data.id);

    // remove data array
    state.selectedIds.data = state.selectedIds.data.filter((file) => file.id !== data.id);
  },
  removeAllSelectedMultiple: (state) => {
    // remove id 
    state.selectedIds.id = [];

    // remove data 
    state.selectedIds.data = [];
  }
}


export const actions = {
  // FILE
  async readFileByFolderId({ commit }, id) {
    commit("fileLoading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
      .get(`/api/FileManager/Simple/Folder/${id}/${userData?.deliveryUnit?.id}`)
      .then((response) => {
        commit("setFileData", response.data);
        commit("fileLoading", false);

        return response;
      })
      .catch(() => {
        commit("fileLoading", false);
      });
  }
}

